export default "__VITE_ASSET__30ae1bdd__"